import { numberToRem } from 'mixins/utilities'

import get from 'lodash/get'
import forEach from 'lodash/forEach'
import forEachRight from 'lodash/forEachRight'

export default {
  methods: {
    repositionOverlappingQuotes() {
      if (this.isBodyLeftQuoteMode) {
        const quotesList = document.querySelectorAll('.article-body-blockquote')

        if (quotesList.length !== 0) {
          // First, move DOWN Overlapping quotes
          this.moveDownOverlappingQuotes(quotesList)

          // If quotes reaches container Limit, END: Move Up, START: move down
          this.moveQuotesWithinContainerLimit(quotesList)
        }
      }
      return false
    },
    getMoveUpPos(currentOffsetTop, currentDOMRect, comparedToDOMRect) {
      return numberToRem(currentOffsetTop - (get(currentDOMRect, 'bottom', 0) - get(comparedToDOMRect, 'top', 0))) // use offset to change the actual position of the quote
    },
    getMoveDownPos(currentOffsetTop, currentDOMRect) {
      return numberToRem(currentOffsetTop + get(currentDOMRect, 'height', 0)) // use offset to change the actual position of the quote
    },
    moveDownOverlappingQuotes(quotesList) {
      forEach(quotesList, (currentBq, index) => {
        if (index <= quotesList.length - 1) {
          const nextBq = quotesList[index + 1]
          const currentDOMRect = currentBq ? currentBq.getBoundingClientRect() : false
          const nextDOMRect = nextBq ? nextBq.getBoundingClientRect() : false

          if (currentDOMRect) {
            // Move down overlapping next quote
            if (nextBq && currentDOMRect.bottom >= nextDOMRect.top) {
              nextBq.style.top = this.getMoveDownPos(currentBq.offsetTop, currentDOMRect)
            }
          }
        }
      })
    },
    moveQuotesWithinContainerLimit(quotesList) {
      const containerEl = get(this, '$refs[articleBody]', false)
      const containerElDOMRect = containerEl ? containerEl.getBoundingClientRect() : false

      const nonQuoteEl = get(document.querySelectorAll('.unblock-left-quote'), '[0]', false)
      const nonQuoteElDOMRect = nonQuoteEl ? nonQuoteEl.getBoundingClientRect() : false

      if (containerElDOMRect) {
        // CONTAINER END (move up quote): First, if quotes are after container END, move quotes UP within the container END
        forEachRight(quotesList, (currentBq, index) => {
          if (index <= quotesList.length - 1) {
            const currentDOMRect = currentBq ? currentBq.getBoundingClientRect() : false

            if (currentDOMRect) {
              if (currentDOMRect.bottom >= containerElDOMRect.bottom) {
                // To move up to container END: Get the pos of the container end, less the current item height
                const breaklimitBottomPos = containerElDOMRect.bottom - currentDOMRect.top
                const moveToBottomPos = currentBq.offsetTop + breaklimitBottomPos
                const getMoveUpPos = moveToBottomPos - currentDOMRect.height
                currentBq.style.top = numberToRem(getMoveUpPos)
              }
            }
          }
        })

        // QUOTE over NON-QUOTE ELEMENTS (move up quote): After moving up, also check for quotes overlapping non-quote elements
        if (nonQuoteElDOMRect) {
          forEachRight(quotesList, (currentBq, index) => {
            if (index <= quotesList.length - 1) {
              const prevBq = quotesList[index - 1]
              const nextBq = quotesList[index + 1]
              const currentDOMRect = currentBq ? currentBq.getBoundingClientRect() : false
              const nextDOMRect = nextBq ? nextBq.getBoundingClientRect() : false

              if (currentDOMRect) {
                // Check if Overlaping within the non-quote element and move quotes UP
                if (currentDOMRect.bottom >= nonQuoteElDOMRect.top && currentDOMRect.top <= nonQuoteElDOMRect.bottom) {
                  // While within non-quote element, Move up the quote that overlapps the non-quote element, then move up the overlapping quotes
                  currentBq.style.top = currentDOMRect.bottom >= nextDOMRect.top ?
                    this.getMoveUpPos(currentBq.offsetTop, currentDOMRect, nextDOMRect) :
                    this.getMoveUpPos(currentBq.offsetTop, currentDOMRect, nonQuoteElDOMRect)
                } else if (prevBq && currentDOMRect.bottom >= nextDOMRect.top) {
                  // Move up the quotes if it overlapps the quotes that just moved up within the non-quote element as long as there is a previous quote
                  currentBq.style.top = this.getMoveUpPos(currentBq.offsetTop, currentDOMRect, nextDOMRect)
                }
              }
            }
          })
        }

        // OVERLAPPING QUOTES (move up quotes): Then, Loop again to check overlapping elements and Move quotes UP
        forEachRight(quotesList, (currentBq, index) => {
          if (index <= quotesList.length - 1) {
            const nextBq = quotesList[index + 1]
            const currentDOMRect = currentBq ? currentBq.getBoundingClientRect() : false
            const nextDOMRect = nextBq ? nextBq.getBoundingClientRect() : false

            if (currentDOMRect && nextDOMRect) {
              if (currentDOMRect.bottom >= nextDOMRect.top) {
                currentBq.style.top = this.getMoveUpPos(currentBq.offsetTop, currentDOMRect, nextDOMRect)
              }
            }
          }
        })

        // CONTAINER START (move down quotes): Then, if quotes are before container START, move quotes DOWN within the container START
        forEach(quotesList, (currentBq, index) => {
          if (index <= quotesList.length - 1) {
            const currentDOMRect = currentBq ? currentBq.getBoundingClientRect() : false

            if (currentDOMRect) {
              if (currentDOMRect.top <= containerElDOMRect.top) {
                // To move down to the container START: Get the pos of the container start
                const breaklimitTopPos = containerElDOMRect.top - currentDOMRect.top
                const moveToTopPos = currentBq.offsetTop + breaklimitTopPos
                currentBq.style.top = numberToRem(moveToTopPos)
              }
            }
          }
        })

        // OVERLAPPING QUOTES (move down quotes): Lastly, Loop again to check overlapping elements and Move quotes Down
        this.moveDownOverlappingQuotes(quotesList)

        // CONTAINER END + NON-QUOTE ELEMENTS: For extreme case, after moveDownOverlappingQuotes(), if a non-quote element is still blocking a quote if beyond the containter END, move down the non-quote element
        if (nonQuoteElDOMRect) {
          forEach(quotesList, (currentBq, index) => {
            if (index <= quotesList.length - 1) {
              const currentDOMRect = currentBq ? currentBq.getBoundingClientRect() : false

              if (currentDOMRect) {
                // Check if there are quotes after container END
                if (currentDOMRect.bottom >= containerElDOMRect.bottom) {
                  if (currentDOMRect.bottom >= nonQuoteElDOMRect.top && currentDOMRect.top <= nonQuoteElDOMRect.bottom) {
                    // Move the non-element down the Quote: Get the pos of the quote end to move non-quote element down
                    const breaklimitBottomPos = currentDOMRect.bottom - nonQuoteElDOMRect.top
                    const moveToBottomPos = nonQuoteEl.offsetTop + breaklimitBottomPos
                    nonQuoteEl.style.top = numberToRem(moveToBottomPos)
                  }
                }
              }
            }
          })
        }
      }
    },
  },
}



// WEBPACK FOOTER //
// ./components/mixins/overlappingQuotes.js